import Vue from "vue";
import moment from "moment";
import "moment/min/moment-with-locales";
import "moment/locale/es";

Vue.use(require("vue-moment"), {
  moment,
});
